import { render, staticRenderFns } from "./InlineBoxComunications.vue?vue&type=template&id=36ee96dd"
import script from "./InlineBoxComunications.vue?vue&type=script&lang=js"
export * from "./InlineBoxComunications.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxComunications.vue?vue&type=style&index=0&id=36ee96dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports